import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";

export default {
  name: "DataSIgnalSiteSummaryPopup",
  components: {
    customModal,
  },
  props: {
    data: [],
  },
    data(){
        return {
        head:{},
        idToken:"",
        baseUrl: process.env.VUE_APP_Service_URL,
        studyId: "",
        defaultdate: "",
        };
    },
    async mounted() {
        console.log("data in site summary popup", this.data);
            this.idToken = store.getters.getIdToken;
            this.defaultdate = localStorage.getItem("dateformat");
        }, 
        methods: {  
            closeModal() {
                this.$emit("closeModal");
            },
            filter(date) {
              if (date) {
                return moment(date).format(this.defaultdate)
              }
            },
        }
}